<template>
  <div class="panel">
    <b-alert :variant="users.flashType" :show="!!users.flash">
      {{ users.flash }}
    </b-alert>
    <b-row class="mb-4">
      <b-col>
        <h2 class="mq">Users</h2>
      </b-col>
      <b-col class="text-right">
        <b-button :to="{ name: 'adminNewUser' }" variant="rounded">
          Add user
          <Icon name="add" />
        </b-button>
      </b-col>
    </b-row>
    <b-tabs ref="bTab" v-model="tabIndex" card class="tabs-users">
      <b-tab
        v-for="(tab, index) in filteredTabs"
        :key="tab.value"
        :title="tab.label"
        :active="index === 0"
        class="px-0 pt-0"
      >
        <paginated-list
          v-if="!!users.data[0] && tab.value === users.data[0].role"
          :items="users"
          :set-page-callback="setPage"
          :per-page="perPage"
          :loading="$store.getters.activeLoaders('paginatedList')"
        >
          <template slot="items">
            <UsersGroup
              :users-list="usersList"
              @edit="handleEditUser"
              @remove="openRemoveUserModal"
            />
          </template>
        </paginated-list>
      </b-tab>
    </b-tabs>
    <b-modal
      ref="modal"
      v-model="removeUserDialog"
      ok-title="Delete"
      cancel-title="Cancel"
      ok-variant="rounded btn-delete"
      cancel-variant="link"
      @ok="removeUser"
      @hide="resetSelectedUser"
    >
      <p class="lead">Are you sure you want to delete?</p>
      You won't be able to undo your action.
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import UserMethods from '@/components/mixins/users-methods';
import PaginatedList from '@/components/shared/paginated-list';
import UsersGroup from '@/components/admin/users/users-group';

const PER_PAGE = 25; // should never be lower than paginated totalCount/totalPages
const TABS = [
  {
    index: 0,
    label: 'Superadmins',
    value: 'superadmin',
    protected: true
  },
  {
    index: 1,
    label: 'Admins',
    value: 'admin',
    protected: false
  },
  {
    index: 2,
    label: 'Users',
    value: 'user',
    protected: false
  },
  {
    index: 3,
    label: 'Engineers',
    value: 'engineer',
    protected: false
  }
];
export default {
  name: 'AdminUsersList',
  components: { PaginatedList, UsersGroup },
  mixins: [UserMethods],
  data() {
    return {
      removeUserDialog: false,
      selectedUserId: null,
      tabIndex: 0,
      tabs: TABS,
      perPage: PER_PAGE
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.auth && state.auth.userID,
      users: state => state.users
    }),
    filteredTabs() {
      if (this.isSuperadmin) return this.tabs;

      return this.tabs.filter(tab => !tab.protected);
    },
    usersList() {
      if (this.currentUserId) {
        const potentialCurrentUser = this.users.data[0];

        if (!!potentialCurrentUser && potentialCurrentUser.id === this.currentUserId) {
          potentialCurrentUser.current = true;
        }

        return this.users.data;
      }
      return [];
    }
  },
  watch: {
    tabIndex: {
      handler(index) {
        const query = {
          page: 0,
          role: this.filteredTabs[index].value
        };

        this.fetchPage(query);
      },
      immediate: true
    }
  },
  destroyed() {
    this.$store.commit('users/resetStore');
  },
  methods: {
    ...mapActions({
      fetchPage: 'users/fetchPage'
    }),
    setPage(page) {
      const query = {
        page,
        role: this.filteredTabs[this.tabIndex].value
      };

      this.$store.dispatch('users/fetchPage', query);
    },
    removeUser() {
      this.$store.dispatch('users/removeUser', { userId: this.selectedUserId });
      this.setPage(0);
    },
    handleEditUser(userId) {
      this.$router.push({ name: 'adminEditUser', params: { userId } });
    },
    openRemoveUserModal(userId) {
      this.selectedUserId = userId;
      this.removeUserDialog = !this.removeUserDialog;
    },
    resetSelectedUser() {
      this.selectedUserId = null;
    }
  }
};
</script>
